export const COLORS = {
  primary: "#BF1E2D",
  text_black_color: "#010F07",
  text_opacity_black_color: "rgba(59, 59, 59,0.3)",
  text_grey_color: "#9C9C9C",
  text_grey_color2: "#9AA0B4",
  text_grey_color3: "#616161",
  text_dark_grey_color: "#5D5D5D",
  text_dark_grey_color2: "#727272",
  disabled_btn_color: "#9A9A9A",
  text_light_black_color: "#484848",
  text_blue_color: "#0082CB",
  placeholder_text_color: "#AEAEAE",
  border_color: "#EAEAEA",
  light_border_color: "#D7D7D7",
  input_text_color: "#050505",
  selected_input_border: "#2A2F3D",
  light_grey: "#E7E7E7",
  light_grey2: "#F8F8F8",
  light_grey3: "#F0F0F0",
  light_grey4: "#E6E6E6",
  search_bar_background: "#FCFCFD",
  background_grey: "#F7F8FB",
  background_dark_grey: "#C9C9C9",
  text_dark_grey_color: "#363636",
  header_icon_shadow_color: "#D3D1D8",
  light_background: "#F2F2F7",
  light_red: "#FFDFE5",
  green_color: "#32BA7C",
  yellow_color: "#FEBB00",
  sea_green: "#33B099",
  decline_order: "#DD5A62",
  light_green: "#67E053",
  light_blue_color: "#F2F9FF",
  white: "#fff",
  black: "#000",
  transparent: "transparent",
};

export const SIZES = {
  // global sizes
  base: 8,
  font: 14,
  radius_sm: 4,
  radius: 30,
  padding: 20,
  padding2: 12,

  // font sizes
  h9: 9,
  h10: 10,
  h11: 11,
  h12: 12,
  h13: 13,
  h14: 14,
  h15: 15,
  h16: 16,
  h17: 17,
  h18: 18,
  h19: 19,
  h20: 20,
  h21: 21,
  h22: 22,
  h23: 23,
  h24: 24,
  h25: 25,
  h26: 26,
  h27: 27,
  h28: 28,
  h30: 30,
  h32: 32,
};
const apiUrl = process.env.REACT_APP_API_URL;
let UTILS;

if (apiUrl === "http://localhost:3000/kanban") {
  UTILS = {
    Env:'local',
    // API_url: "https://development.tgcrm.net/api/",
    // Base_url: "https://development.tgcrm.net/",
    // temp_image_url:
    //   "https://development.tgcrm.net/public/assets/images/board-list-card/",
    // // images_url: "https://development.tgcrm.net/public/assets/images/board-list-card/",
    // // files_url: "https://development.tgcrm.net/public/assets/images/board-list-card/",
    // images_url: "https://trelloassets.tgcrm.net/",
    // files_url: "https://trelloassets.tgcrm.net/",
    // websocket: "ws://localhost:8080",

    // Live Testing
    API_url: "https://tgcrm.net/api/",
    Base_url: "https://tgcrm.net/",
    temp_image_url: "https://tgcrm.net/public/assets/images/board-list-card/",
    images_url: "https://trelloassets.tgcrm.net/",
    files_url: "https://trelloassets.tgcrm.net/",
    websocket: "ws://localhost:8080",
  };
} else {
  UTILS = {
    Env:'live',
    API_url: "https://tgcrm.net/api/",
    Base_url: "https://tgcrm.net/",
    temp_image_url: "https://tgcrm.net/public/assets/images/board-list-card/",
    images_url: "https://trelloassets.tgcrm.net/",
    files_url: "https://trelloassets.tgcrm.net/",
  };
}

export { UTILS };

export const FONTS = {
  // Bold Fonts
  Bold30: {
    fontFamily: "Poppins-Bold",
  },
  Bold20: {
    fontFamily: "Poppins-Bold",
  },

  // SemiBold
  SemiBold28: {
    fontFamily: "Poppins-SemiBold",
  },
  SemiBold22: {
    fontFamily: "Poppins-SemiBold",
  },
  SemiBold18: {
    fontFamily: "Poppins-SemiBold",
  },
  SemiBold12: {
    fontFamily: "Poppins-SemiBold",
  },

  // Medium Fonts

  Medium20: {
    fontFamily: "Poppins-Medium",
  },
  Medium18: {
    fontFamily: "Poppins-Medium",
  },
  Medium16: {
    fontFamily: "Poppins-Medium",
  },
  Medium14: {
    fontFamily: "Poppins-Medium",
  },
  Medium13: {
    fontFamily: "Poppins-Medium",
  },
  Medium12: {
    fontFamily: "Poppins-Medium",
  },
  Medium11: {
    fontFamily: "Poppins-Medium",
  },
  Medium10: {
    fontFamily: "Poppins-Medium",
  },

  // Regular Fonts

  Regular20: {
    fontFamily: "Poppins-Regular",
  },
  Regular17: {
    fontFamily: "Poppins-Regular",
  },
  Regular16: {
    fontFamily: "Poppins-Regular",
  },
  Regular15: {
    fontFamily: "Poppins-Regular",
  },
  Regular14: {
    fontFamily: "Poppins-Regular",
  },
  Regular13: {
    fontFamily: "Poppins-Regular",
  },
  Regular12: {
    fontFamily: "Poppins-Regular",
  },
  Regular10: {
    fontFamily: "Poppins-Regular",
  },
  Regular11: {
    fontFamily: "Poppins-Regular",
  },
  Regular10: {
    fontFamily: "Poppins-Regular",
  },
  Regular9: {
    fontFamily: "Poppins-Regular",
  },

  // Light FOnts

  Light12: {
    fontFamily: "Poppins-Light",
  },
  Light11: {
    fontFamily: "Poppins-Light",
  },
};

const appTheme = { COLORS, SIZES, FONTS };

export default appTheme;
